import { SectionHeader, NavButtons, Badge, levelClass } from "@/components/workflow/ui";
import { ClipboardList } from "lucide-react";

export default function StepDifferentials({ differentials, onBack, onNext }) {
  return (
    <div data-testid="differentials-section">
      <SectionHeader icon={ClipboardList} sub="Step 5 · System" title="Differential diagnosis" />
      {differentials.clinical_reasoning && <p className="text-sm text-zinc-600 -mt-2 mb-6">{differentials.clinical_reasoning}</p>}
      <div className="space-y-px bg-zinc-200 border border-zinc-200 rounded-md overflow-hidden">
        {differentials.differentials?.map((d, i) => (
          <div key={d.condition || i} className="bg-white p-5">
            <div className="flex items-center justify-between gap-3">
              <h3 className="font-serif text-lg text-zinc-900">{d.condition}</h3>
              <Badge className={levelClass(d.probability)}>{d.probability}</Badge>
            </div>
            <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              <p className="text-zinc-700"><span className="font-semibold text-green-700">Supports:</span> {d.supporting_features}</p>
              <p className="text-zinc-700"><span className="font-semibold text-red-700">Against:</span> {d.against_features}</p>
            </div>
            {d.reference && <p className="mt-2 text-xs text-zinc-400">Ref: {d.reference}</p>}
          </div>
        ))}
      </div>
      <NavButtons onBack={onBack} onNext={onNext} nextLabel="Order investigations" nextTestId="order-investigations-btn" />
    </div>
  );
}
